import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AuthContext } from '../../contexts/AuthContext';

const Sitemap = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const isDev = process.env.NODE_ENV === 'development';

  const routes = [
    { path: "/", name: "Home", group: "General" },
    { path: "/home", name: "Home", group: "General" },
    { path: "/login", name: "Login", group: "Authentication" },
    { path: "/login/participant", name: "Participant Login", group: "Authentication" },
    { path: "/register", name: "Register", group: "Authentication" },
    { path: "/register-success", name: "Register Success", group: "Authentication" },
    { path: "/forgot-password", name: "Forgot Password", group: "Authentication" },
    { path: "/reset-password/:uid/:token", name: "Reset Password", group: "Authentication" },
    { path: "/dashboard", name: "Dashboard", group: "Main" },
    { path: "/studies", name: "Studies", group: "Studies" },
    { path: "/sites", name: "All Sites", group: "Sites" },
    { path: "/participants", name: "All Participants", group: "Participants" },
    { path: "/create-new-study", name: "Create New Study", group: "Studies" },
    { path: "/studies/:studyID", name: "Single Study", group: "Studies" },
    { path: "/studies/:studyID/sites", name: "Study Sites", group: "Sites" },
    { path: "/studies/:studyID/add-site", name: "Add Site", group: "Sites" },
    { path: "/studies/:studyID/sites/:siteID/", name: "Site Details", group: "Sites" },
    { path: "/studies/:studyID/sites/:siteId/participants/", name: "Site Participants", group: "Participants" },
    { path: "/studies/:studyID/sites/:siteId/participants/add-participant", name: "Add Participant", group: "Participants" },
    { path: "/studies/:studyID/sites/:siteId/participant/:participantID/", name: "Participant Details", group: "Participants" },
    { path: "/studies/:studyID/edit", name: "Edit Study", group: "Studies" },
    { path: "/user-manager", name: "User Manager", group: "Administration" },
    { path: "/data-visualization", name: "Data Visualization", group: "Analysis" },
    { path: "/surveys", name: "Surveys", group: "Data Collection" },
    { path: "/file-upload", name: "File Upload", group: "Data Management" },
    { path: "/sites/:siteID/edit", name: "Edit Site", group: "Sites" },
    { path: "/dcq/", name: "DCQs", group: "Data Collection" },
    { path: "/dcq/:dcqId/", name: "Single DCQ", group: "Data Collection" },
    { path: "/dcq/create/", name: "Create DCQ", group: "Data Collection" },
    { path: "/rolerequests", name: "Role Requests", group: "Administration" },
    { path: "/profile", name: "User Profile", group: "User" },
    { path: "/session-expired", name: "Session Expired", group: "Error" },
    { path: "/server-error", name: "Server Error", group: "Error" },
    { path: "/unknown-error", name: "Unknown Error", group: "Error" },
    ...(isDev ? [
      { path: "/sitemap", name: "Sitemap", group: "Development" },
      { path: "/development", name: "Development", group: "Development" }
    ] : []),
  ];

  const groupedRoutes = routes.reduce((acc, route) => {
    (acc[route.group] = acc[route.group] || []).push(route);
    return acc;
  }, {});

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-primary-700 mb-12 text-center">Sitemap</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {Object.entries(groupedRoutes).map(([group, routes]) => (
            <motion.div
              key={group}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-lg dark:shadow-gray-900/20 overflow-hidden"
            >
              <div className="px-6 py-4 bg-primary-600">
                <h2 className="text-xl font-semibold text-white">{group}</h2>
              </div>
              <ul className="px-6 py-4 space-y-2">
                {routes.map((route, index) => (
                  <li key={index}>
                    <Link
                      to={route.path}
                      className="text-primary-600 hover:text-primary-800 transition-colors duration-200"
                    >
                      {route.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Sitemap;